import {Model} from '@vuex-orm/core';
import User from "./userModel";
import moment from 'moment';

export default class ContactPoint extends Model {

    static entity = 'contactPoint';
    static primaryKey = 'id_contact_point';

    static fields() {
        return {
            id_contact_point: this.attr('new'),
            title: this.string(null),
            content: this.string(''),
            id_user: this.attr(null),
            id_partner: this.attr(null),
            id_task: this.attr(null),
            type: this.attr(null),
            created_at: this.attr(moment().format("YYYY-MM-DD HH:mm:ss")),
            user: this.hasOne(User, 'id_user', 'id_user'),
        };
    }

    static mapTypeToIconName(contactPoint) {
        switch (contactPoint.type) {
            case 0:
                return 'email';
            case 1:
                return 'phone';
            case 2:
                return 'mailbox';
            case 3:
                return 'account-multiple';
            case 4:
                return 'fax';
            default:
                return null;
        }
    }

}